module.exports = __webpack_public_path__ + "media/images/page/reason_illust02-a746b3bf84235ca9d1179d9db1bb7684.png";